module.exports = __webpack_public_path__ + "static/media/2_pl.2b3a01c8.png";